<div class="subbanner">
  <div class="container position-relative">
    <div class="subbanner__title">
      <h1 class="primary-title">Memorable Mice</h1>
    </div>
  </div>
</div>
<div class="container padding-section" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
  <div class="row">
    <div class="col-md-12">
      <ul role="tablist" role="navigation" ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        <li [ngbNavItem]="1" >
          <a ngbNavLink class="main-heading-destini" role="tab">
            International Destinations 
          </a>
          <ng-template ngbNavContent>
            <div class="inter-padding pl-2">
              <p style="color: red">
                Incentive Ideas - Meaningful, Motivational & Memorable MICE
              </p>
              <p style="font-weight: 500">
                What makes incentive travel experiences more meaningful,
                motivational and memorable from the participant's viewpoint?
              </p>
              <p>
                Incentive or motivational travel rewards allow the building of
                relationships with peers away from work. They give participants
                the opportunity to experience something unique as a group,
                something that they could not do on their own. Recognition also
                generates the desire to continue to excel and earn similar rewards
                in subsequent programs.
              </p>
              <p>
                Here are some great destinations for MICE tours and suggestions
                for interesting activities there. Each destination offers unique
                opportunities and possibilities to make your tour a truly Kesari
                MICE experience.
              </p>
              <!-- #docregion multi -->
              <div id="happycorporate" class="faq section-bg">
                <div class="">
                  <mat-accordion class="example-headers-align" *ngFor="let item of internationalDestinations">
                    <mat-expansion-panel>
                      <mat-expansion-panel-header class="main-accordion-hedgs">
                        {{ item.Sector }}
                      </mat-expansion-panel-header>

                      <mat-accordion class="example-headers-align" *ngFor="let subsector of item.data">
                        <mat-expansion-panel>
                          <mat-expansion-panel-header class="subheading">
                            <mat-panel-title class="country-undecity-hdng">
                              {{ subsector.Sub_Sector }}
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <!-- <p style="font-weight: 500">{{ subsector.Title }}</p> -->
                          <!-- {{subsector|json}} -->
                          <ul class="acc-list">
                            <!-- {{description|json}} -->
                            <li *ngFor="let item2 of subsector.data">
                              {{item2.Description}}
                            </li>
                          </ul>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </mat-expansion-panel>
                  </mat-accordion>


                </div>
              </div>
            </div>
          </ng-template>
        </li>
        <!-- ======= Frequently Asked Questions Section ======= -->

        <li [ngbNavItem]="2">
          <a ngbNavLink class="main-heading-destini" role="tab">Indian Destinations</a>
          <ng-template ngbNavContent>
            <div class="inter-padding pl-2">
              <p style="color: red">
                Incentive Ideas - India as a MICE destination
              </p>
              <p style="font-weight: 500">
                A heady cocktail of old-world charm and vibrant modernism, India
                is truly an uber attractive MICE destination
              </p>
              <p>
                What makes the country different from any other destination are
                the myriad experiences it offers. From the snow-capped peaks of
                the Himalayas to the palm-fringed beaches of the south, from
                cities pulsating with life to lush jungles, sylvan hill stations
                and sand-swept deserts, there's so much to choose from.
              </p>
              <p>
                Apart from the countless ways that India captures world attention
                as a tourist paradise, it also offers dynamic business
                opportunities, and acts as a splendid venue for international
                conferences and conventions of global standards. Exotic,
                mystical heritage sites, beach and adventure destinations also
                provide great options for pre and post conference tours.
              </p>
              <p>
                There’s no doubt about it - India is certainly a destination of
                choice for the discerning MICE traveller.
              </p>
              <div id="happycorporate" class="faq section-bg">
                <div class="" data-aos="fade-up">
                  <mat-accordion class="example-headers-align" *ngFor="let item of domesticDestinations">
                    <mat-expansion-panel>
                      <mat-expansion-panel-header class="main-accordion-hedgs">
                        {{ item.Sector }}
                      </mat-expansion-panel-header>

                      <mat-accordion class="example-headers-align" *ngFor="let subsector of item.data">
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title class="country-undecity-hdng">
                              {{ subsector.Sub_Sector }}
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <!-- <p style="font-weight: 500">{{ subsector.Title }}</p> -->
                          <!-- {{subsector|json}} -->
                          <ul class="acc-list">
                            <li *ngFor="let item2 of subsector.data">
                              {{item2.Description}}
                            </li>
                          </ul>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>


</div>